import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { EpxButtonStackComponent } from '@shared/components/buttons/epx-button-stack/epx-button-stack.component';
import { EpxSvgIconComponent } from '@shared/components/misc/epx-svg-icon/epx-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'epx-confirm-dialog',
    template: `
        <p-confirmDialog key="epx-confirm" #cd [style]="{ width: 'fit-content', maxWidth: '30vw' }" [header]="cd.header">
            <ng-template pTemplate="footer">
                <div class="flex flex-row justify-content-end">
                    <app-epx-button-stack>
                        @if (cd.rejectVisible) {
                            <p-button severity="secondary" outlined [label]="cd.rejectLabel || 'BUTTONS.NO' | translate" (onClick)="cd.onReject()">
                                <epx-svg-icon icon="plus" rotation="45deg"></epx-svg-icon>
                            </p-button>
                        }
                        @if (cd.acceptVisible) {
                            <p-button severity="contrast" [label]="cd.acceptLabel || 'BUTTONS.YES' | translate" (onClick)="cd.onAccept()">
                                <epx-svg-icon icon="check_mark"></epx-svg-icon>
                            </p-button>
                        }
                    </app-epx-button-stack>
                </div>
            </ng-template>
        </p-confirmDialog>
    `,
    styleUrls: ['./epx-confirm-dialog.component.scss'],
    imports: [ConfirmDialogModule, ButtonModule, EpxButtonStackComponent, EpxSvgIconComponent, TranslatePipe]
})
export class EpxConfirmDialogComponent {}
